import { faArrowUpFromSquare } from '@fortawesome/pro-light-svg-icons/faArrowUpFromSquare'
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark'
import { faSquarePlus } from '@fortawesome/pro-regular-svg-icons/faSquarePlus'
import Icon from '@space-lib/components/icon'
import Modal from '@space-lib/components/modal'
import ModalBody from '@space-lib/components/modalBody'
import ModalHeader from '@space-lib/components/modalHeader'
import MobileHeaderExample from '@space-shell/assets/images/mobile-header-example.png'
import { useTranslation } from 'react-i18next'

import * as S from './style'

import type { PwaIosModalParams } from './types'

const PwaIosModal = ({ isModalOpen, handleCloseModal }: PwaIosModalParams) => {
  const { t } = useTranslation()

  return (
    <Modal show={isModalOpen} onClose={handleCloseModal}>
      <ModalHeader>
        <S.ModalHeaderContainer>
          <S.ModalHeaderTitle>{t('pwa.modal.title')}</S.ModalHeaderTitle>

          <S.ModalHeaderCloseButton onClick={handleCloseModal} aria-label='modal-close'>
            <span className='_sr-only'>close</span>
            <Icon icon={faXmark} className='_w-5 _h-5' />
          </S.ModalHeaderCloseButton>
        </S.ModalHeaderContainer>
      </ModalHeader>
      <ModalBody>
        <S.ModalBodyContent>
          <S.ModalBodyContentSteps>
            <h4>1. {t('pwa.modal.step_1')}</h4>
            <S.ModalBodyContentStepIconRounded>
              <div>
                <Icon icon={faArrowUpFromSquare} size='lg' />
              </div>
            </S.ModalBodyContentStepIconRounded>
          </S.ModalBodyContentSteps>
          <S.ModalBodyContentSteps>
            <h4>2. {t('pwa.modal.step_2')}</h4>
            <S.ModalBodyContentStepIconRectangle>
              {t('pwa.modal.step_3.text')}
              <Icon icon={faSquarePlus} size='lg' />
            </S.ModalBodyContentStepIconRectangle>
          </S.ModalBodyContentSteps>
          <S.ModalBodyContentSteps>
            <h4>3. {t('pwa.modal.step_3.title')}</h4>
            <S.ModalBodyContentStepIconWithImage>
              <img src={MobileHeaderExample} alt='mobile header example' />
              <div>
                <span className='blue'>{t('pwa.modal.step_3.btn_cancel')}</span>
                <span>{t('pwa.modal.step_3.text')}</span>
                <span className='blue'>{t('pwa.modal.step_3.btn_add')}</span>
              </div>
            </S.ModalBodyContentStepIconWithImage>
          </S.ModalBodyContentSteps>
        </S.ModalBodyContent>
      </ModalBody>
    </Modal>
  )
}

export default PwaIosModal
